import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import useMmcService from "../../services/MmcService";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import MmcTextInput from "../pages/MmcTextInput";
import {Consts} from "../pages/consts";

const Login = ({ onLogin, showDialog }) => {
  const { t } = useTranslation();

  const { loading, error, clearError, login } = useMmcService();

  const doLogin = (values) => {
    clearError();

    if (values === null) {
      return onLogin(null, null);
    }

    const body = {
      name: values.username,
      password: values.password,
    };

    login(body).then((loginResult) => handleLoginResponse(loginResult));
  };

  const handleLoginResponse = (loginResult) => {
    if (loginResult) {
      const { token, role, userId, login, studyId } = loginResult;
      onLogin(token, role, userId, login, studyId);
    }
  };

  const errorMessage = error && (
    <ErrorMessage message={`${t("error")} ${error} - ${t("try_again")}.`} />
  );
  const spinner = loading && <Spinner />;

  return (
    <Formik
      initialValues={{ username: "", password: "" }}
      validationSchema={Yup.object({
        username: Yup.string().required(t("required_field")),
        password: Yup.string().required(t("required_field")),
      })}
      onSubmit={(values) => doLogin(values)}
    >
      <Form>
        <div
          className="w3-modal"
          style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
        >
          <div className="w3-modal-content w3-card-4 w3-animate-top w3-theme-l3 login-panel nice-login-panel">
            <header className="w3-container w3-center nice-login-header">
              <h3 className="nice-login-title">{t("log_in")}</h3>
              <p className="nice-login-subtitle">{t("please_enter_your_safepolymed_login_data")}</p>
            </header>
            <div className="w3-container nice-login-body">
              {errorMessage && (<div className="nice-login-error">{errorMessage}</div>)}
              {spinner}
              <MmcTextInput
                label={t("username")}
                id={Consts.USERNAME}
                name={Consts.USERNAME}
                type={Consts.TEXT}
                placeholder={t("your_username")}
              />
              <MmcTextInput
                label={t("password")}
                id={Consts.PASSWORD}
                name={Consts.PASSWORD}
                type={Consts.PASSWORD}
                placeholder={t("your_password")}
              />
            </div>
            <footer className="w3-container nice-login-footer">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://safepolymedac.ics.forth.gr/ac/password-reset/"
                className="nice-login-link"
              >
                <label className="label-link">{t("forgot_password")}</label>
              </a>
              <div className="nice-login-actions">
                <button
                  className="w3-btn w3-round-xlarge w3-theme-d5 "
                  type="submit"
                >
                  {t("log_in")}
                </button>
                <button
                  className="w3-btn w3-round-xlarge nice-login-secondary-button"
                  onClick={() => doLogin(null, null)}
                  type="button"
                >
                  {t("cancel")}
                </button>
              </div>
            </footer>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default Login;
